
<template>
      <v-card>
        <v-toolbar color="green" dark>
            <v-toolbar-title>{{ proposta.modelo_faturamento === 'pospago' ? 'Solicitações de crédito' : 'Recarga saldo empresa' }}</v-toolbar-title>
        </v-toolbar>

      <div v-if="recargas_solicitadas.length">
        <v-list
          v-for="(item, i) in recargas_solicitadas"
          :key="i"
          subheader
          three-line
        >
          <v-subheader>{{ proposta.modelo_faturamento === 'pospago' ? 'Solicitação' : 'Recarga' }}: {{i+1}}</v-subheader>
          <v-list-tile >

            <v-list-tile-content>
              <v-list-tile-title>CNPJ Empresa: {{item.proposta.empresa_id}}</v-list-tile-title>
              <v-list-tile-sub-title>Data solicitação: {{item.data_abertura  | formatDate('DD/MM/YYYY') }}</v-list-tile-sub-title>
              <v-list-tile-sub-title>Valor recarga: {{item.valor_recarga}}</v-list-tile-sub-title>
              <a target="_blank" v-if="item.comprovante_pagamento" :href="item.comprovante_pagamento">Acesse o comprovante aqui</a>
            </v-list-tile-content>

              <v-list-tile-action style="width: 40%;">
                <v-layout justify-space-around>
                  <v-btn small v-if="item.status == null" color="error" @click="responderRecarga(item, false)">Rejeitar</v-btn>
                  <v-btn small v-if="item.status == null" color="success" @click="responderRecarga(item, true)">Aprovar</v-btn>
                  <span v-else :class="item.status == true ? 'success--text' : 'error--text'" class="text-xs-left">{{item.status == true ? 'Aprovada' : 'Rejeitada'}} em: {{item.data_confirmacao | formatDate('DD/MM/YYYY') }}</span>
                </v-layout>
            </v-list-tile-action>
          </v-list-tile>

        </v-list>
        </div>
        <div v-else>
          <span  class="text-xs-left pt-3 red--text">Ainda não há recargas solicitadas</span>
        </div>
         <v-card-actions>
          <v-btn flat color="red" @click="cancelar">Fechar</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
      </v-card>
</template>

<script>

export default {
  props: ['proposta'],
  data () {
    return {
      aprovar: false
    }
  },
  mounted () {
    this.carregarRecargasSolicitadas()
  },
  computed: {
    recargas_solicitadas () {
      return this.$store.getters.recargas_propostas
    }
  },
  methods: {
    cancelar () {
      this.$emit('fechar')
    },
    carregarRecargasSolicitadas () {
      var data = {
        empresa: this.proposta.empresa.cnpj,
        proposta: this.proposta.id
      }
      this.$store.dispatch('buscarRecargasPorProposta', data)
    },
    responderRecarga (recarga, resposta) {
      var data = {
        id: recarga.id,
        status: resposta
      }
      this.$store.dispatch('aprovarRecargaProposta', data)
      this.$emit('fechar')
    }
  }
}

</script>
